import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import {
  Activity,
  Airplay,
  ArrowDownToLine,
  Bell,
  BrainCircuit,
  Building2,
  Cable,
  CalendarClock,
  CalendarDays,
  CalendarFold,
  CalendarRange,
  ChartBar,
  ChartColumn,
  ChartColumnBig,
  ChartNoAxesCombined,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  ClockArrowUp,
  CodeXml,
  Cog,
  CopyPlus,
  Droplet,
  EllipsisVertical,
  Eraser,
  Eye,
  EyeClosed,
  FileChartPie,
  FileCog,
  FileInput,
  FileMinus,
  FileSearch,
  FileSliders,
  FileText,
  Folders,
  HardDrive,
  Hash,
  Home,
  House,
  HousePlug,
  Info,
  Key,
  Layers,
  LayoutDashboard,
  Lightbulb,
  ListTree,
  LoaderCircle,
  LucideEye,
  LucideEyeOff,
  Mail,
  MapPinned,
  Moon,
  Newspaper,
  PanelLeftClose,
  PanelLeftOpen,
  Pencil,
  PieChart,
  Plus,
  RadioTower,
  ReceiptText,
  RefreshCcwDot,
  RefreshCw,
  Scale,
  ScanText,
  Search,
  Server,
  SquareArrowOutUpRight,
  SquaresIntersect,
  SquaresSubtract,
  SquaresUnite,
  StickyNote,
  Sun,
  Table2,
  TableCellsSplit,
  TableProperties,
  Tag,
  Tags,
  Terminal,
  TextQuote,
  ThumbsUp,
  Trash2,
  TriangleAlert,
  User,
  UserLock,
  VenetianMask,
  X,
  ZoomIn,
} from 'lucide-vue-next'
import { computed } from 'vue'

import InfoCustom from '../icons/InfoCustom.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Icons',
  props: {
    action: {},
    variant: {},
    icon: {},
    size: {},
    strokeWidth: {},
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const getVariants = (variant: 'filters' | 'actions' | 'danger' | 'default' | 'disabled') => {
  switch (variant) {
    case 'filters':
      return 'rounded min-h-8 min-w-8 w-8 h-8 border border-[var(--p-primary-color)] text-[var(--p-primary-color)] hover:bg-[var(--p-primary-100)] dark:hover:bg-[var(--p-primary-800)]'
    case 'actions':
      return 'text-[var(--p-primary-color)]'
    case 'danger':
      return 'rounded min-h-8 min-w-8 w-8 h-8 border border-red-600 text-red-600 hover:bg-red-50 dark:border-red-400 dark:text-red-400 dark:hover:bg-red-950'
    case 'disabled':
      return 'rounded min-h-8 min-w-8 w-8 h-8 text-gray-400 border border-gray-400 !cursor-not-allowed dark:text-gray-600 dark:border-gray-600'
    case 'default':
      return 'rounded min-h-8 min-w-8 w-8 h-8 text-[var(--p-primary-color)] hover:bg-[var(--p-primary-100)] dark:hover:bg-[var(--p-primary-800)]'
  }
}

const iconComponent = computed(() => {
  switch (__props.icon) {
    case 'activity':
      return Activity
    case 'home':
      return Home
    case 'file-cog':
      return FileCog
    case 'mass-command':
      return FileInput
    case 'time-slot':
      return ClockArrowUp
    case 'micro-adjustment':
      return Airplay
    case 'reading':
      return FileText
    case 'download':
      return ArrowDownToLine
    case 'file-search':
      return FileSearch
    case 'register':
      return Plus
    case 'refresh':
      return RefreshCw
    case 'details':
      return ZoomIn
    case 'edit':
      return Pencil
    case 'tags':
      return Tags
    case 'tag':
      return Tag
    case 'delete':
      return Trash2
    case 'map':
      return MapPinned
    case 'table':
      return TableCellsSplit
    case 'pie-chart':
      return PieChart
    case 'triangle-alert':
      return TriangleAlert
    case 'thumbs-up':
      return ThumbsUp
    case 'info':
      return Info
    case 'info-custom':
      return InfoCustom
    case 'table-properties':
      return TableProperties
    case 'bell':
      return Bell
    case 'hard-drive':
      return HardDrive
    case 'server':
      return Server
    case 'newspaper':
      return Newspaper
    case 'house-plug':
      return HousePlug
    case 'scale':
      return Scale
    case 'terminal':
      return Terminal
    case 'venetian-mask':
      return VenetianMask
    case 'list-tree':
      return ListTree
    case 'layers':
      return Layers
    case 'sticky-note':
      return StickyNote
    case 'user':
      return User
    case 'search':
      return Search
    case 'eye':
      return Eye
    case 'eye-closed':
      return EyeClosed
    case 'mail':
      return Mail
    case 'key':
      return Key
    case 'file-sliders':
      return FileSliders
    case 'calendar-fold':
      return CalendarFold
    case 'scan-text':
      return ScanText
    case 'cable':
      return Cable
    case 'hash':
      return Hash
    case 'folders':
      return Folders
    case 'chart-column-big':
      return ChartColumnBig
    case 'chart-column':
      return ChartColumn
    case 'chart-bar':
      return ChartBar
    case 'table-2':
      return Table2
    case 'house':
      return House
    case 'report':
      return FileChartPie
    case 'billing':
      return CalendarRange
    case 'calendar-clock':
      return CalendarClock
    case 'text-quote':
      return TextQuote
    case 'cog':
      return Cog
    case 'closeMenu':
      return PanelLeftClose
    case 'openMenu':
      return PanelLeftOpen
    case 'chevron-down':
      return ChevronDown
    case 'chevron-up':
      return ChevronUp
    case 'check':
      return Check
    case 'cancel':
      return X
    case 'management':
      return CopyPlus
    case 'eye-open':
      return LucideEye
    case 'eye-closed':
      return LucideEyeOff
    case 'chart-no-axes-combined':
      return ChartNoAxesCombined
    case 'receipt-text':
      return ReceiptText
    case 'squares-intersect':
      return SquaresIntersect
    case 'squares-unite':
      return SquaresUnite
    case 'squares-subtract':
      return SquaresSubtract
    case 'trash':
      return Trash2
    case 'network':
      return RadioTower
    case 'redirect':
      return SquareArrowOutUpRight
    case 'clients':
      return Building2
    case 'mass-delete':
      return FileMinus
    case 'clean':
      return Eraser
    case 'dots':
      return EllipsisVertical
    case 'reprocess':
      return RefreshCcwDot
    case 'lightbulb':
      return Lightbulb
    case 'code-xml':
      return CodeXml
    case 'layout-dashboard':
      return LayoutDashboard
    case 'user-lock':
      return UserLock
    case 'lightbulb':
      return Lightbulb
    case 'droplet':
      return Droplet
    case 'brain-circuit':
      return BrainCircuit
    case 'moon':
      return Moon
    case 'sun':
      return Sun
    default:
      return __props.icon
  }
})

const click = () => {
  if (!__props.action) return
  !__props.isLoading ? __props.action() : null
}



function handleClick() {
  if (__props.variant != 'disabled') {
    click()
  }
  return
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex cursor-pointer items-center justify-center group-hover:scale-110", getVariants(__props.variant || 'default')]),
    onClick: handleClick
  }, [
    (!__props.isLoading)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponent.value), {
          key: 0,
          size: __props.size || 16,
          "stroke-width": __props.strokeWidth || 2.5
        }, null, 8, ["size", "stroke-width"]))
      : (_openBlock(), _createBlock(_unref(LoaderCircle), {
          key: 1,
          size: __props.size || 16,
          "stroke-width": __props.strokeWidth || 2.5,
          class: "animate-spin-slow"
        }, null, 8, ["size", "stroke-width"]))
  ], 2))
}
}

})